<template>
  <div>
    <el-dialog :title="$t('Mərhələ')" :close-on-press-escape="false" :close-on-click-modal="false" :visible.sync="showModal"
      width="50%" top="30vh" append-to-body>
      <div clas="row">
        <div class="d-flex flex-column">
          <div class="p-2">
            <label>{{$t('Zərər_vuran')}}</label>
            &nbsp;
            <el-select style="display: flex" @input="inputInsurance" :placeholder="$t('Seçin')" filterable
              :value="item.insuranceParticipantId">
              <el-option v-for="item in participants" :key="item.id" :label="item.fullName" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="p-2">
            <label for="">{{$t('Zərər_çəkən')}}</label>
            &nbsp;
            <el-select style="display: flex" :placeholder="$t('Seçin')" @input="inputOs" filterable
              :value="item.osParticipantId">
              <el-option v-for="item in filteredOsParticipants" :key="item.id" :label="item.fullName" :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="save">{{$t('Yadda_saxla')}}</el-button>
        <el-button size="small" @click="showModal = false">{{$t('İmtina')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>


<script>
import { ClaimType } from "../../services/types";
import { CreateClaim } from "../../services/claim";
import { GetParticipants } from "../../services/accident";
export default {
  data() {
    return {
      activeName: "person",
      showModal: false,
      loading: false,
      participants: [],
      item: {},
      uid: this.$store.state.user.id,
    };
  },
  computed: {
    filteredInsuranceParticipants() {
      return this.participants.filter(item => item.participantType === 1);
    },
    filteredOsParticipants() {
      // Filter participants based on the selected insurance participant
      if (this.item.insuranceParticipantId) {
        return this.participants.filter(item => item.id !== this.item.insuranceParticipantId);
      }
      // If no insurance participant is selected, show all OS participants
      return this.participants
    }
  },
  methods: {
    inputInsurance(e) {
      this.$emit("input", e);
      this.item.insuranceParticipantId = e;
      this.item.osParticipantId = null;
    },
    inputOs(e) {
      this.$emit("input", e);
      this.item.osParticipantId = e;
    },
    getParticipants() {
      GetParticipants(this.item.accidentId).then((response) => {
        this.partloading = false;
        if (response.data) {
          this.participants = response.data.data;
        }
      });
    },
    new(id) {
      this.item = new ClaimType();
      this.mode = "New";
      this.showModal = true;
      this.item.accidentId = id;
      this.getParticipants();
    },

    save() {
      this.loading = true;
      let claim = Object.assign({}, this.item);
      claim.commandUserId = this.uid;
      if (this.item.insuranceParticipantId === this.item.osParticipantId) {
        this.$message({
          type: "warning",
          message: this.$t('Sığortalı_ve_Qarşı_tərəf_eyni_ola_bilməz'),
        });
        return;
      }
      if (this.mode === "New") {
        CreateClaim(claim).then((response) => {
          this.loading = false;
          if (response.data) {
            if (!response.data.isSuccess) {
              this.$message({
                type: "error",
                message: response.data.errors[0],
              });
            } else {
              this.$emit("saved", { action: "new", id: response.data.value });
              this.showModal = false;
              this.$message({
                type: "success",
                message: this.$t('Uğurlu_əməliyyat'),
              });
            }
          } else {
            this.$message({
              type: "error",
              message: this.$t('Səhv_əməliyyat'),
            });
          }
        });
      }
    },
  },
};
</script>


<style lang="scss" scoped></style>